import styles from './styles/jaasPeople.module.css';

import personThumbnail from '../assets/logo-square.jpeg';
import vincent from './common/vincent-abolarin.png';

const JaasPeople = () => {
    return (
        <div className={styles.jaasPeople}>
            <h3 className={styles.peopleHeading}>
                JAAS People
            </h3>
            <div className={styles.jaasPersons}>
                <div className={`${styles.personContainer} ${styles.personContainerKingsley}`}>
                    <div className={styles.personIdentityRoleThumbnail}>
                        <div className={styles.personIdentityRole}>
                            <div className={styles.personIdentity}>
                                <h3 className={styles.personName}>
                                    Kingsley Udeagha
                                </h3>
                                
                            </div>

                            <div className={styles.personRole}>
                                <p className={styles.roleText}>
                                    Project Manager
                                </p>

                                <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.roleIcon}>
                                <path d="M8.66656 24.75H17.3332C21.6882 24.75 22.4682 22.9388 22.6957 20.7338L23.5082 11.7338C23.8007 8.98875 23.0424 6.75 18.4166 6.75H7.58323C2.95739 6.75 2.19906 8.98875 2.49156 11.7338L3.30406 20.7338C3.53156 22.9388 4.31156 24.75 8.66656 24.75Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.6665 6.75V5.85C8.6665 3.85875 8.6665 2.25 12.1332 2.25H13.8665C17.3332 2.25 17.3332 3.85875 17.3332 5.85V6.75" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.1668 14.625V15.75C15.1668 15.7612 15.1668 15.7613 15.1668 15.7725C15.1668 16.9988 15.156 18 13.0002 18C10.8552 18 10.8335 17.01 10.8335 15.7837V14.625C10.8335 13.5 10.8335 13.5 11.9168 13.5H14.0835C15.1668 13.5 15.1668 13.5 15.1668 14.625Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M23.454 12.375C20.9515 14.265 18.0915 15.39 15.1665 15.7725" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.83838 12.6787C5.27588 14.4112 8.02755 15.4575 10.8334 15.7837" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                        
                            </div>
                        </div>
                        <div className={styles.personThumbnailContainer}>
                            <img src={personThumbnail} alt="Kingsley Udeagha" className={styles.personThumbnail} />
                        </div>
                        
                        
                    </div>
                    

                    <p className={styles.roleDescription}>
                        Kingsley manages and monitors the planning and execution of JAAS projects as well as the performance of products, ensuring that they work optimally for all clients.
                    </p>
                </div>

                <div className={`${styles.personContainer} ${styles.personContainerVincent}`}>
                    <div className={styles.personIdentityRoleThumbnail}>
                        <div className={styles.personIdentityRole}>
                            <div className={styles.personIdentity}>
                                <h3 className={styles.personName}>
                                    Vincent Abolarin
                                </h3>
                                
                            </div>

                            <div className={styles.personRole}>
                                <p className={styles.roleText}>
                                    Frontend Engineer
                                </p>

                                <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.roleIcon}>
                                <path d="M8.66656 24.75H17.3332C21.6882 24.75 22.4682 22.9388 22.6957 20.7338L23.5082 11.7338C23.8007 8.98875 23.0424 6.75 18.4166 6.75H7.58323C2.95739 6.75 2.19906 8.98875 2.49156 11.7338L3.30406 20.7338C3.53156 22.9388 4.31156 24.75 8.66656 24.75Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.6665 6.75V5.85C8.6665 3.85875 8.6665 2.25 12.1332 2.25H13.8665C17.3332 2.25 17.3332 3.85875 17.3332 5.85V6.75" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.1668 14.625V15.75C15.1668 15.7612 15.1668 15.7613 15.1668 15.7725C15.1668 16.9988 15.156 18 13.0002 18C10.8552 18 10.8335 17.01 10.8335 15.7837V14.625C10.8335 13.5 10.8335 13.5 11.9168 13.5H14.0835C15.1668 13.5 15.1668 13.5 15.1668 14.625Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M23.454 12.375C20.9515 14.265 18.0915 15.39 15.1665 15.7725" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.83838 12.6787C5.27588 14.4112 8.02755 15.4575 10.8334 15.7837" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                        
                            </div>
                        </div>
                        <div className={styles.personThumbnailContainer}>
                            <img src={vincent} alt="Vincent Abolarin" className={styles.personThumbnail} />
                        </div>
                        
                        
                    </div>
                    

                    <p className={styles.roleDescription}>
                    Vincent is in charge of frontend activities on all of JAAS products. He ensures pixel-perfect implementation of designs and makes JAAS products' functionality seamless.
                    </p>
                </div>
            </div>

            <div className={styles.jaasPersons}>
                <div className={`${styles.personContainer} ${styles.personContainerSheun}`}>
                    <div className={styles.personIdentityRoleThumbnail}>
                        <div className={styles.personIdentityRole}>
                            <div className={styles.personIdentity}>
                                <h3 className={styles.personName}>
                                    Sheun Lawani
                                </h3>
                                
                            </div>

                            <div className={styles.personRole}>
                                <p className={styles.roleText}>
                                    Backend Engineer
                                </p>

                                <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.roleIcon}>
                                <path d="M8.66656 24.75H17.3332C21.6882 24.75 22.4682 22.9388 22.6957 20.7338L23.5082 11.7338C23.8007 8.98875 23.0424 6.75 18.4166 6.75H7.58323C2.95739 6.75 2.19906 8.98875 2.49156 11.7338L3.30406 20.7338C3.53156 22.9388 4.31156 24.75 8.66656 24.75Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.6665 6.75V5.85C8.6665 3.85875 8.6665 2.25 12.1332 2.25H13.8665C17.3332 2.25 17.3332 3.85875 17.3332 5.85V6.75" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.1668 14.625V15.75C15.1668 15.7612 15.1668 15.7613 15.1668 15.7725C15.1668 16.9988 15.156 18 13.0002 18C10.8552 18 10.8335 17.01 10.8335 15.7837V14.625C10.8335 13.5 10.8335 13.5 11.9168 13.5H14.0835C15.1668 13.5 15.1668 13.5 15.1668 14.625Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M23.454 12.375C20.9515 14.265 18.0915 15.39 15.1665 15.7725" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.83838 12.6787C5.27588 14.4112 8.02755 15.4575 10.8334 15.7837" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                        
                            </div>
                        </div>
                        <div className={styles.personThumbnailContainer}>
                            <img src={personThumbnail} alt="Sheun Lawani" className={styles.personThumbnail} />
                        </div>
                        
                        
                    </div>
                    

                    <p className={styles.roleDescription}>
                    Sheun does all the backend work of JAAS. He manages our databases and APIs and ensures that the frontend has a solid backend to connect to.
                    </p>
                </div>

                <div className={`${styles.personContainer} ${styles.personContainerEmmanuel}`}>
                    <div className={styles.personIdentityRoleThumbnail}>
                        <div className={styles.personIdentityRole}>
                            <div className={styles.personIdentity}>
                                <h3 className={styles.personName}>
                                    Emmanuel Akunne
                                </h3>
                                
                            </div>

                            <div className={styles.personRole}>
                                <p className={styles.roleText}>
                                    UI/UX Designer
                                </p>

                                <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.roleIcon}>
                                <path d="M8.66656 24.75H17.3332C21.6882 24.75 22.4682 22.9388 22.6957 20.7338L23.5082 11.7338C23.8007 8.98875 23.0424 6.75 18.4166 6.75H7.58323C2.95739 6.75 2.19906 8.98875 2.49156 11.7338L3.30406 20.7338C3.53156 22.9388 4.31156 24.75 8.66656 24.75Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.6665 6.75V5.85C8.6665 3.85875 8.6665 2.25 12.1332 2.25H13.8665C17.3332 2.25 17.3332 3.85875 17.3332 5.85V6.75" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.1668 14.625V15.75C15.1668 15.7612 15.1668 15.7613 15.1668 15.7725C15.1668 16.9988 15.156 18 13.0002 18C10.8552 18 10.8335 17.01 10.8335 15.7837V14.625C10.8335 13.5 10.8335 13.5 11.9168 13.5H14.0835C15.1668 13.5 15.1668 13.5 15.1668 14.625Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M23.454 12.375C20.9515 14.265 18.0915 15.39 15.1665 15.7725" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.83838 12.6787C5.27588 14.4112 8.02755 15.4575 10.8334 15.7837" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                        
                            </div>
                        </div>
                        <div className={styles.personThumbnailContainer}>
                            <img src={personThumbnail} alt="Emmanuel" className={styles.personThumbnail} />
                        </div>
                        
                        
                    </div>
                    

                    <p className={styles.roleDescription}>
                    Emmanuel handles JAAS designs, ensuring that users enjoy beautiful user interfaces as well as amazing user experiences.
                    </p>
                </div>
            </div>
            
        </div>
    );
}
 
export default JaasPeople;